// api前缀
// const apiPrefix = '';
// const apiService = {
//   // 主机厂小场景运营管理平台服务
//   vendor: '/vendor',
//   // TAI内部小场景运营管理平台服务
//   management: '/management',
//   // 小场景开发者平台服务
//   developer: '/developer'
// };
export const apiUrl = {
  submitIssue: '/activity/time/issue',
};
